export default __webpack_public_path__ + "static/media/meltano-logo.4acd2a04.svg";